import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { getCaseStyle, formatNull, formatDate, formatDateTime } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import FileViewerModal from '../FileViewerModal';
import ModalRight from '../ModalRight';

import Modal from '../Modal';
import EditAdditionalInsurance from './Components/EditAdditionalInsurance';

import InsuranceCasePanel from './Components/InsuranceCasePanel';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const AdditionalInsurance = ({ caseId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    axios.get(`/api/get-case-insurance?case_id=${caseId}`, {
    headers: {
        Authorization: `Bearer ${token}`,
    }
    })
    .then((response) => {
        setWarning('');
        setCases(response.data);
    })
    .catch((error) => {
        console.error(error);
        setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
        setLoading(false);
        setReload(false);
    })

    axios.get(`/api/get-full-info-case?id=${caseId}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        }
    })
    .then((response) => {
        
    })
    .catch((error) => {
        // if (error.response?.data.action == 'logout') window.location.href = '/auth/logout';
        openTimeModal('У вас недостаточно прав на просмотр содержимого', 'error');
        window.location.href = '/'
        setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
  }, [reload, caseId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-entry', {
      data: { 
        table_name: '',
        entry_id: id,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
  
  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);

  const [currentFileId, setCurrentFileId] = React.useState(null);

  const [isFileViewerModal, setIsFileViewerModal] = React.useState(false);


  return (
    <>
      <ModalRight isOpen={isFileViewerModal} closeModal={() => setIsFileViewerModal(false)} >
          <FileViewerModal closeModal={() => setIsFileViewerModal(false)} id={currentFileId} />
      </ModalRight>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditAdditionalInsurance id={currentId} action={currentAction} caseId={caseId} onSuccess={() => setReload(true)} />
      </Modal>

      <InsuranceCasePanel caseId={caseId} />
      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                    <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                    <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                    </svg>
                    Добавить договор доп. страхования ответственности
                </button>
                <a className='lastUpdateWrapper'>
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => {setReload(true); setLoading(true)}} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{ gridTemplateColumns: '20fr 20fr 10fr 10fr 10fr 10fr 10fr 10fr' }}>
                <div>Страховая компания / Номер договора</div>
                <div>Дата договора</div>
                <div>Дата начала</div>
                <div>Дата окончания</div>
                <div>Страховая сумма</div>
                <div>Страховая премия</div>
                <div>Дата добавления</div>
                <div></div>
            </div>
        </div>
        {(cases.length==0 && loading) ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => { setReload(true); setLoading(true) }} />
        : cases.map((caseItem) => (
            <div 
            className='tableDoubleRow' 
            key={caseItem.id} 
            >
                <div 
                    className='row'
                    style={{ gridTemplateColumns: '20fr 20fr 10fr 10fr 10fr 10fr 10fr 10fr' }}
                >
                    <div>{formatNull(caseItem.insurance_company)} / {formatNull(caseItem.contract_number)}</div>
                    <div>{formatDate(caseItem.date_contract)}</div>
                    <div>{formatDate(caseItem.date_start)}</div>
                    <div>{formatDate(caseItem.date_end)}</div>
                    <div>{formatNull(caseItem.sum_insured)} ₽</div>
                    <div>{formatNull(caseItem.insurance_premium)} ₽</div>
                    <div>{formatDateTime(caseItem.created_at)}</div>
                    <div style={{alignItems: 'end'}}>
                      {/* <IconContainer Icon={PenIcon} onClick={() => {}} size = '16' color = 'blue' className = '' /> */}
                      <IconContainer Icon={TrashIcon} onClick={() => setConfirmDeleteId(caseItem.id)} size='16' color='red' className='' />
                    </div>
                </div>
                <div 
                    className='horizontalRow'
                    style={{ gridTemplateColumns: '1fr' }}
                >
                    {caseItem.files?.length===0 ?
                    <p className='description'>Файлы не прикреплены. Вероятно, произошла ошибка</p>
                    : caseItem.files?.map((fileInfo) => (
                        <button type='button' className='tableButton' onClick={() => {setCurrentFileId(fileInfo.id); setIsFileViewerModal(true)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="file"><path d="M20,8.94a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.09,0L13.06,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V9S20,9,20,8.94ZM14,5.41,16.59,8H14ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V9a1,1,0,0,0,1,1h5Z"></path></svg>
                            {fileInfo.name}
                        </button>
                    ))}
                </div>
            </div>
        ))}
    </div>
    </>
  )
}

export default AdditionalInsurance;